<template>
  <div class="page_title">
    <div class="align py-3 px-4">
      <h1 class="px-1">
        <RedirectBack></RedirectBack>
        <span>Suporte #{{ support.id }}</span>
      </h1>
    </div>
  </div>

  <div v-if="support.id" class="align p-4 space_title">
    <div class="row">
      <div class="col-12">
        <div class="card">
          <div class="p-4">
              <div class="row">
                <div class="col-12 mb-2">
                  <h5>{{ support.title }}</h5>
                  <p class="date">{{ $dateFormat(support.created_at) }}</p>
                </div>


                <div class="col-12">
                  <p class="mb-0" v-html="support.content"></p>
                </div>

                <div v-if="support.attachment" class="col-12 mt-3">
                  <a :href="support.attachment" target="_blank"><WhiteButton><i class="fa-regular fa-paperclip"></i> Anexo</WhiteButton></a>
                </div>
              </div>
          </div>
        </div>


        <div v-for="(reply, key) in support.replies" :key="key" class="card mt-4">
          <div class="p-4">
              <div class="row">
                <div class="col-12">
                  <strong>{{ reply.author_name }}</strong>
                  <p class="date">{{ $dateFormat(reply.created_at) }}</p>
                </div>

                <div class="col-12">
                  <p class="mb-0" v-html="reply.content"></p>
                </div>

                <div v-if="reply.attachment" class="col-12 mt-4">
                  <a :href="support.attachment" target="_blank"><WhiteButton><i class="fa-regular fa-paperclip"></i> Anexo</WhiteButton></a>
                </div>
              </div>
          </div>
        </div>
      
      <div v-if="support.status !== 'finalized'" class="col-8">
        <div class="card mt-4">
          <div class="p-4">
              <div class="row">
                <div class="col-12 mb-3">
                  <h6 class="mb-3">Responder suporte</h6>
                  <TextArea style="height: 150px;" v-model="reply.content" :error="formErrors.content" />
                </div>
                <div class="col-12">
                  <FileUpload v-model="reply.attachment" :error="formErrors.attachment" />
                </div>
                <div class="col-12 mt-3">
                  <PrimaryButton @click="submit()" class="px-5">Responder</PrimaryButton>
                </div>
              </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  </div>
</template>
  
<script setup>
import PrimaryButton from '@/components/PrimaryButton.vue'
import WhiteButton from '@/components/WhiteButton.vue'
import FileUpload from '@/components/FileUpload.vue'
import TextArea from '@/components/TextArea.vue'
import RedirectBack from '@/components/RedirectBack.vue'
import { useSupportStore } from '@/stores/SupportStore'
import { inject, onMounted, ref } from 'vue';
import { useToast, TYPE } from "vue-toastification";
import { useRoute, useRouter } from 'vue-router';
import { storeToRefs } from 'pinia';
import {errorFormat} from "@/utils/errorFormat";
const toast = useToast();

const loader = inject('$loader');

const formErrors = ref({});

const supportStore = useSupportStore();
const { support, reply } = storeToRefs(supportStore);

const route = useRoute();
const router = useRouter();

onMounted(async () => {
  supportStore.support = {};

  const id = route.params.id;
  if(id){
    loader.show();
    await supportStore.getSupport(id);
    loader.hide();
  }
});

const submit = async() => {
    let params = {
      attachment: supportStore.reply.attachment,
      content: supportStore.reply.content,
    };

    loader.show();
    formErrors.value = {};

    if(supportStore.support.id){
      const formResult = await supportStore.addSupportReply(supportStore.support.id, params);
      if(formResult.success){
        supportStore.reply = {}
        toast('Suporte respondido', { type: TYPE.SUCCESS, timeout: 6000 });
      }
      else {
        formErrors.value = errorFormat(formResult.errors);
      }
    }
    else {
      const formResult = await supportStore.addSupport(params);
      if(formResult.success){
        toast('Suporte enviado', { type: TYPE.SUCCESS, timeout: 6000 });
        router.push({ name: 'supports'});
      }
      else {
        formErrors.value = errorFormat(formResult.errors);
      }
    }

    loader.hide();
};
</script>

<style scoped>
.image_upload {
  height: 150px;
  background-color: #ebebeb;
  border-radius: 4px;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  cursor: pointer;
}

.image_upload:hover {
  background-color: #d7d7d7;
}

.image_upload h4 {
  font-size: 18px;
  margin-bottom: 0;
}

.image_upload span {
  font-size: 14px;
  font-weight: 600;
  color: #7f7f7f;
}

.date {
  color: #747474;
}
</style>